import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HomeComponent } from './components/core/main/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { MainBlockComponent } from './components/core/main/main-block/main-block.component';
import { AboutComponent } from './components/core/main/about/about.component';
import { PossibilitiesComponent } from './components/core/main/possibilities/possibilities.component';
import { AdvantagesComponent } from './components/core/main/advantages/advantages.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { ReviewsComponent } from './components/core/main/reviews/reviews.component';
import { FaqComponent } from './components/core/main/faq/faq.component';
import { ContactComponent } from './components/core/main/contact/contact.component';
import { FooterComponent } from './components/footer/footer.component';
import { ConditionComponent } from './components/core/conditions/condition.component';
import { PrivacyComponent } from './components/core/privacy/privacy.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDivider } from '@angular/material/divider';
import { IconComponent } from './components/icon/icon.component';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChip } from '@angular/material/chips';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { PartnersComponent } from './components/core/main/partners/partners.component';
import { SlickCarouselModule } from 'ngx-slick-carousel-ver2';
import { OlxComponent } from './components/core/olx/olx.component';
import { AutoRiaComponent } from './components/core/auto-ria/auto-ria.component';
import { AgroRiaComponent } from './components/core/agro-ria/agro-ria.component';
import { DomRiaComponent } from './components/core/dom-ria/dom-ria.component';
import { InstagramComponent } from './components/core/instagram/instagram.component';
import { TelegramComponent } from './components/core/telegram/telegram.component';
import { ViberComponent } from './components/core/viber/viber.component';
import { ButtonComponent } from './components/button/button.component';
import { NgOptimizedImage } from '@angular/common';
import { InterfaceForAllComponent } from './components/interface-for-all/interface-for-all.component';
import { IntegrationReviewComponent } from './components/integration-review/integration-review.component';
import { PromComponent } from './components/core/prom/prom.component';
import { WhatsAppComponent } from './components/core/whats-app/whats-app.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    MainBlockComponent,
    AboutComponent,
    PossibilitiesComponent,
    AdvantagesComponent,
    PricingComponent,
    ReviewsComponent,
    FaqComponent,
    ContactComponent,
    FooterComponent,
    ConditionComponent,
    PrivacyComponent,
    IconComponent,
    PartnersComponent,
    OlxComponent,
    AutoRiaComponent,
    AgroRiaComponent,
    DomRiaComponent,
    InstagramComponent,
    TelegramComponent,
    ViberComponent,
    DomRiaComponent,
    InstagramComponent,
    TelegramComponent,
    ViberComponent,
    ButtonComponent,
    InterfaceForAllComponent,
    IntegrationReviewComponent,
    PromComponent,
    WhatsAppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
    }),
    FormsModule,
    NgSelectModule,
    MatDivider,
    MatIconModule,
    MatBadgeModule,
    MatChip,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatExpansionModule,
    SlickCarouselModule,
    NgOptimizedImage,
  ],
  providers: [
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
